<template>
  <section class="py-6">
    <hr class="pb-6 max-w-sm mx-auto" />
    <slot />
  </section>
</template>
